import { controls,grouped } from "../controls";
const account_house_details = {
label: "Account House Details",
pageLabel: "Account House Details",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Address",uid: "address"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "House Type Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "house_type_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Builder Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "builder_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Area Sqft"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "area_sqft",maxlength:13}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Ready Recknor Rate"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "ready_recknor_rate",maxlength:21}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Listed Price"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "listed_price",maxlength:13}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Sale Price"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "sale_price",maxlength:13}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Invoice Number"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "invoice_number",maxlength:20}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Valuator Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "valuator_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "House Type",star:false}),
...controls.oc({ tab: "general", c: "HouseType", placeHolder: "House Type Code", name: "house_type_code", isRequired:false,fastpath:"house_types"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "house_type_display"}),
...controls.displayText({ tab: "general", label: "Vendor",star:false}),
...controls.oc({ tab: "general", c: "Vendor", placeHolder: "Vendor Code", name: "vendor_code", isRequired:false,fastpath:"vendors"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "vendor_display"}),
...controls.displayText({ tab: "general", label: "Area Sqft"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "area_sqft",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Ready Recknor Rate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "ready_recknor_rate",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Listed Price"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "listed_price",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Sale Price"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "sale_price",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Invoice Number",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "invoice_number",isRequired:false,maxlength:20}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Valuator",star:false}),
...controls.oc({ tab: "general", c: "Valuator", placeHolder: "Valuator Code", name: "valuator_code", isRequired:false,fastpath:"valuators"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "valuator_display"}),
...controls.displayText({ tab: "address", label: "Line 1",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.line_1",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "address", label: "Line 2",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.line_2",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "address", label: "Line 3",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.line_3",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "address", label: "Village",star:true}),
...controls.oc({ tab: "address", c: "Village", placeHolder: "Village Code", name: "address.village_code", isRequired:true,fastpath:"villages"}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.village_display"}),
...controls.displayText({ tab: "address", label: "Taluka",star:true}),
...controls.oc({ tab: "address", c: "Taluka", placeHolder: "Taluka Code", name: "address.taluka_code", isRequired:true,fastpath:"talukas"}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.taluka_display"}),
...controls.displayText({ tab: "address", label: "District",star:true}),
...controls.oc({ tab: "address", c: "District", placeHolder: "District Code", name: "address.district_code", isRequired:true,fastpath:"districts"}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.district_display"}),
...controls.displayText({ tab: "address", label: "State",star:true}),
...controls.oc({ tab: "address", c: "State", placeHolder: "State Code", name: "address.state_code", isRequired:true,fastpath:"states"}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.state_display"}),
...controls.displayText({ tab: "address", label: "Country",star:true}),
...controls.oc({ tab: "address", c: "Country", placeHolder: "Country Code", name: "address.country_code", isRequired:true,fastpath:"countries"}),
...controls.showData({ tab: "address", displaytype: "capital", data: "address.country_display"}),
...controls.displayText({ tab: "address", label: "Pincode",star:false}),
...controls.text({ tab: "address",  placeHolder: "", name: "address.pincode",isRequired:false,maxlength:6}),
...controls.displayText({ tab: "address", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Account House Details",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "House Type Id",accessor: "house_type_id",},
{Header: "Builder Id",accessor: "builder_id",},
{Header: "Area Sqft",accessor: "area_sqft",},
{Header: "Ready Recknor Rate",accessor: "ready_recknor_rate",},
{Header: "Listed Price",accessor: "listed_price",},
{Header: "Sale Price",accessor: "sale_price",},
{Header: "Invoice Number",accessor: "invoice_number",},
{Header: "Valuator Id",accessor: "valuator_id",},
]}};
export default account_house_details;